<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="root-container">
    <header>
      <img class="logo" src="../assets/images/logo.png" style="width: 30px;">
      <span class="logo-label">食联健康-用户端</span>
    </header>
    <div class="login-container">
      <div class="login-form">
        <el-form v-if="loginType === 'userCode'" v-loading="loading" element-loading-text="登录中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.5)" style="height: 100%;">
          <div class="login-type-div">用户登录</div>
          <div class="login-error-tip login-form-div">{{errorTip}}</div>
          <div class="login-form-div">
            <input type="text" class="login-form-input" placeholder="用户名" v-model="form.rawCode" />
            <input type="password" class="login-form-input" placeholder="密码" v-model="form.password" />
          </div>
          <div class="login-button-area">
            <el-button type="warning" style="width: 100%;" v-on:click="handlerLogin">登录</el-button>
          </div>
        </el-form>
        <div v-if="loginType === 'wxQRCode'" class="wx-qrcode">
          <iframe width="300" height="400" :src="logurl"></iframe>
        </div>
        <div class="login-type-container">
          <div v-if="loginType === 'wxQRCode'" @click="loginType='userCode'">
            <img src="../assets/images/password.png" alt="">
            <span>账号<br />登录</span>
          </div>
          <div v-else @click="loginType='wxQRCode'">
            <img src="../assets/images/wx.png" alt="">
            <span>微信<br />登录</span>
          </div>
        </div>
      </div>
      <img class="login-img" src="../assets/images/login-img.png" />
    </div>
    <footer>&copy; 2021 - 食联健康食品产业互联网平台 | 技术支持：大连易智造科技有限公司</footer>
  </div>
</template>
<style scoped>
.login-form > .wx-qrcode {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  overflow: hidden;
  z-index: 9;
}
.login-form > .wx-qrcode > iframe {
  display: block;
  border: none;
  margin: 0 auto;
}
.login-type-container {
  position: absolute;
  width: 40px;
  right: 0px;
  top: 0px;
  z-index: 19;
}
.login-type-container > div {
  width: 100%;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
}
.login-type-container > div > img {
  display: block;
  margin: 0 auto;
  width: 80%;
}
</style>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      form: {
        rawCode: '',
        password: ''
      },
      menus: [
        {
          id: 4,
          parent_id: 0,
          name: '企业管理',
          route_path: '',
          children: [
            {
              id: 41,
              parent_id: 4,
              name: '企业信息',
              route_path: '/company/form',
              children: []
            },
            {
              id: 42,
              parent_id: 4,
              name: '认证变更记录',
              route_path: '/company/list',
              children: []
            }
          ]
        },
        {
          id: 2,
          parent_id: 0,
          name: '供求管理',
          route_path: '/supply/list',
          children: []
        },
        {
          id: 3,
          parent_id: 0,
          name: '名片管理',
          route_path: '/card/form',
          children: []
        }
      ],
      errorTip: '',
      loading: false,
      logurl: '',
      loginType: 'wxQRCode'
      // logObj: new WxLogin({
      //   self_redirect:true,
      //   // 显示二维码的容器的id
      //   id:"login_container", 
      //   appid: "wx618ef610849c3156", 
      //   scope: "snsapi_login",
      //   // 重定向地址
      //   redirect_uri: "",
      //   state: "",
      //   style: "",
      //   href: ""
      // })
    }
  },
  mounted: function () {
    let _this = this
    window.onkeydown = function (e) {
      if (e.keyCode === 13) {
        _this.handlerLogin()
      }
    }
    this.getQrImage()
  },
  methods: {
    handlerLogin: function () {
      let _this = this
      if (_this.form.rawCode === '') {
        _this.errorTip = '用户名不能为空'
        return
      }
      if (_this.form.password === '') {
        _this.errorTip = '密码不能为空'
        return
      }
      _this.loading = true
      _this.post(_this.$apis.login, _this.form, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'ok') {
          sessionStorage.setItem('user', JSON.stringify(_json.user))
          if (_json.user.company_id !== '0') {
            _this.menus.push({
              id: 0,
              parent_id: 0,
              name: '云官网管理',
              route_path: '',
              children: [
                {
                  id: 10,
                  parent_id: 0,
                  name: '站点信息管理',
                  route_path: '/website/form',
                  children: []
                },
                {
                  id: 11,
                  parent_id: 0,
                  name: '导航管理',
                  route_path: '/website/navigation',
                  children: []
                },
                {
                  id: 12,
                  parent_id: 0,
                  name: '内容管理',
                  route_path: '/article/list',
                  children: []
                },
                {
                  id: 13,
                  parent_id: 0,
                  name: '产品管理',
                  route_path: '/production/list',
                  children: []
                },
                {
                  id: 14,
                  parent_id: 0,
                  name: '设备管理',
                  route_path: '/equipment/list',
                  children: []
                },
                {
                  id: 15,
                  parent_id: 0,
                  name: '幻灯片管理',
                  route_path: '/website/slider',
                  children: []
                }
              ]
            })
            sessionStorage.setItem('menus', JSON.stringify(_this.menus))
          } else {
            sessionStorage.setItem('menus', JSON.stringify(_this.menus))
          }
          _this.$router.push({
            path: '/home'
          })
        } else {
          _this.errorTip = '用户名或密码错误'
        }
        _this.loading = false
      })
    },
    getQrImage: function () {
      let redirect_uri = 'https%3A%2F%2Fwww.worenzheng.cn%2Fapp%2Fuser%2Findex.html%23%2Fhome'
      let url =  'https://open.weixin.qq.com/connect/qrconnect?appid=wxa08b409b6551b86c' + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_login&href=https://www.worenzheng.cn/app/user/wxQRCode.css'
      this.logurl = url
      // return ''
    }
  }
}
</script>